import { CheckCircle2, Clock, Zap, FileText } from "lucide-react";
import { REASONS } from "@/lib/site-data";

const ICONS = [CheckCircle2, Clock, Zap, FileText];

export const WhyUs = () => {
  return (
    <section id="pourquoi" data-testid="why-section" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="eyebrow mb-4">Pourquoi BGTP</div>
          <h2 className="font-heading text-5xl md:text-6xl uppercase tracking-tight leading-[0.9] text-white">
            <span className="silver-text">Le sérieux</span> du local,<br />
            l'efficacité <span className="text-bgtp-orange">d'un pro.</span>
          </h2>
          <p className="mt-6 text-white/70 text-base leading-relaxed">
            BGTP, c'est une entreprise locale basée à Saint-Didier-sur-Chalaronne qui
            s'engage sur chaque chantier — petit ou gros — avec la même rigueur. Vous
            parlez directement à la personne qui réalise le travail.
          </p>
          <div className="mt-10 divider-orange w-32" />
          <div className="mt-6 grid grid-cols-3 gap-4">
            {[
              ["+10", "Ans d'expérience"],
              ["100%", "Devis gratuit"],
              ["48h", "Réponse devis"],
            ].map(([k, v]) => (
              <div key={k} className="border-l-2 border-bgtp-orange pl-3">
                <div className="font-heading text-3xl text-white tracking-wider">{k}</div>
                <div className="text-[10px] tracking-[0.18em] uppercase text-bgtp-steel">{v}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5">
          {REASONS.map((r, i) => {
            const Icon = ICONS[i] || CheckCircle2;
            return (
              <div key={r.title} data-testid={`reason-${i}`} className="industrial-card">
                <Icon className="w-8 h-8 text-bgtp-orange mb-5" strokeWidth={2} />
                <div className="font-heading text-2xl uppercase tracking-wider text-white mb-2">{r.title}</div>
                <p className="text-sm text-white/70 leading-relaxed">{r.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
